<template>
    <div>
        <!-- 移动端卡片模式 -->
        <div v-if="cardMode" class="space-y-3">
            <!-- 整理文件按钮卡片 -->
            <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div @click="tidyFolderCheckBox = true" class="flex items-center justify-between cursor-pointer">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-primary/10 rounded-lg">
                                <svg t="1733030023556" class="w-6 h-6 fill-primary" viewBox="0 0 1024 1024"
                                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10797">
                                    <path
                                        d="M512 133.034667L180.736 298.666667 512 464.298667 843.264 298.666667 512 133.034667z m19.072-85.845334l426.666667 213.333334a42.666667 42.666667 0 0 1 0 76.330666l-426.666667 213.333334a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333334a42.666667 42.666667 0 0 1 0-76.330666l426.666667-213.333334a42.581333 42.581333 0 0 1 38.144 0z m388.522667 426.666667a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 677.632l407.594667-203.776z m0 213.333333a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 890.965333l407.594667-203.776z" />
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('整理文件') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('按目录分类整理音乐文件') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 删除文件夹按钮卡片 -->
            <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <button @click="$refs.remove_folder.showModal()" :disabled="isLoading"
                        class="flex items-center justify-between w-full text-left">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-error/10 rounded-lg">
                                <svg class="w-6 h-6 fill-error" viewBox="0 0 14 14"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z" />
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('删除文件夹') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('删除空文件夹或无音乐文件夹') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
        </div>

        <!-- 桌面端原有模式 -->
        <div v-else>
            <!-- 整理文件按钮 -->
            <div class="mt-2">
                <div for="tidy-folder"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('整理文件')" @click="tidyFolderCheckBox = true">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                        <svg t="1733030023556" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="10797" width="200" height="200">
                            <path
                                d="M512 133.034667L180.736 298.666667 512 464.298667 843.264 298.666667 512 133.034667z m19.072-85.845334l426.666667 213.333334a42.666667 42.666667 0 0 1 0 76.330666l-426.666667 213.333334a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333334a42.666667 42.666667 0 0 1 0-76.330666l426.666667-213.333334a42.581333 42.581333 0 0 1 38.144 0z m388.522667 426.666667a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 677.632l407.594667-203.776z m0 213.333333a42.666667 42.666667 0 0 1 38.186666 76.330667l-426.666666 213.333333a42.581333 42.581333 0 0 1-38.144 0l-426.666667-213.333333a42.666667 42.666667 0 0 1 38.186667-76.330667L512 890.965333l407.594667-203.776z">
                            </path>
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('整理文件') }}</div>
                    </span>
                </div>
            </div>

            <!-- 删除文件夹按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="$refs.remove_folder.showModal()"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('删除文件夹')" :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg class="icon fill-current w-16 h-5" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z" />
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('删除文件夹') }}</div>
                    </span>
                </button>
            </div>
        </div>

        <!-- 通用 Drawer (移动端和桌面端共用) -->
        <!-- 整理文件 Drawer -->
        <div class="drawer">
            <input id="tidy-folder" type="checkbox" class="drawer-toggle" name='tidy-folder'
                v-model="tidyFolderCheckBox" />
            <div class="drawer-side">
                <div @click="tidyFolderCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>

                <div class="p-4 min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4">
                    <div class="flex justify-between items-center mb-4">
                        <div class="text-xl font-medium">{{ $tt('整理文件') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="handleTidy">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm ml-1" @click="tidyFolderCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    <div class="p-4 space-y-6">
                        <div class="bg-info/10 p-4 rounded-lg border border-info/20">
                            <div class="text-sm text-base-content/80">
                                {{ $tt('整理文件夹，按一级目录，二级目录选定的信息分类') }}
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">{{ $tt('整理后的根目录') }}</span>
                            </label>
                            <input type="text" :placeholder="$tt('请输入根目录路径')"
                                class="input input-bordered focus:input-accent w-full"
                                v-model="tidyFormData.root_path" />
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text font-medium">{{ $tt('目录层级设置') }}</span>
                            </label>
                            <div class="space-y-3">
                                <div v-for="(input, index) in tidyFormData.dir_list" :key="index"
                                    class="p-3 border border-base-200 rounded-lg">
                                    <div class="flex items-center justify-between mb-2">
                                        <span class="text-sm font-medium">{{ $tt('第{index}层目录', { index: index + 1 }) }}</span>
                                        <button class="btn btn-circle btn-ghost btn-xs text-error"
                                            @click="removeInput(index)">
                                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M6 18L18 6M6 6l12 12"></path>
                                            </svg>
                                        </button>
                                    </div>
                                    <single-select v-model="input.value" :options="translateOptions(tidyList)" :placeholder="$tt('请选择')">
                                    </single-select>
                                    <div v-if="input.value === 'custom'" class="mt-2">
                                        <label class="label">
                                            <span class="label-text text-sm">{{ $tt('自定义变量') }}</span>
                                        </label>
                                        <input type="text" :placeholder="$tt('请输入自定义变量，例如：${artist}-${album}')"
                                            class="input input-sm input-bordered w-full" v-model="input.value2" />
                                    </div>
                                </div>
                                <button class="btn btn-outline btn-sm gap-2 w-full" @click="addInput">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                                    </svg>
                                    {{ $tt('添加目录层级') }}
                                </button>
                            </div>
                        </div>

                        <div class="form-control">
                            <label class="label cursor-pointer justify-start gap-4">
                                <span class="label-text font-medium">{{ $tt('启用音乐洗版') }}</span>
                                <input type="checkbox" class="toggle toggle-warning"
                                    v-model="ruleForm.is_clean_music" />
                            </label>
                            <div class="mt-2 p-3 bg-warning/10 rounded-lg border border-warning/20">
                                <div class="text-sm text-base-content/80">
                                    {{ $tt('音乐洗版就是按以下规则换更好的版本') }}
                                </div>
                            </div>
                        </div>

                        <div v-if="ruleForm.is_clean_music"
                            class="space-y-4 p-4 bg-base-200/50 rounded-lg border border-base-200">
                            <h4 class="font-medium text-base-content">{{ $tt('洗版规则配置') }}</h4>

                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('格式优先级') }}</span>
                                </label>
                                <multi-select :options="translateOptions(formatList)" v-model="ruleForm.clean_format_priority">
                                </multi-select>
                            </div>

                            <div class="grid grid-cols-1 gap-4">
                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('文件大小规则') }}</span>
                                    </label>
                                    <single-select v-model="ruleForm.clean_size_rule" :options="translateOptions(sizeRuleList)"
                                        :placeholder="$tt('请选择')">
                                    </single-select>
                                </div>

                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('比特率规则') }}</span>
                                    </label>
                                    <single-select v-model="ruleForm.clean_bitrate_rule" :options="translateOptions(bitRuleList)"
                                        :placeholder="$tt('请选择')">
                                    </single-select>
                                </div>

                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('采样率/位深规则') }}</span>
                                    </label>
                                    <single-select v-model="ruleForm.clean_sample_rule" :options="translateOptions(sampleRuleList)"
                                        :placeholder="$tt('请选择')">
                                    </single-select>
                                </div>

                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('文件名规则') }}</span>
                                    </label>
                                    <single-select v-model="ruleForm.clean_name_rule" :options="translateOptions(nameRuleList)"
                                        :placeholder="$tt('请选择')">
                                    </single-select>
                                </div>

                                <div class="form-control">
                                    <label class="label">
                                        <span class="label-text font-medium">{{ $tt('删除策略') }}</span>
                                    </label>
                                    <single-select v-model="ruleForm.clean_delete_rule" :options="translateOptions(deleteRuleList)"
                                        :placeholder="$tt('请选择')">
                                    </single-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 删除文件夹 Modal -->
        <dialog id="remove_folder" ref="remove_folder" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box w-full max-w-2xl">
                <!-- 标准头部设计 -->
                <div class="flex items-center justify-between pb-4 border-b border-base-200">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-error/10 rounded-lg">
                            <svg class="w-6 h-6 fill-error" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M9 0H5V1.5L9 1.5V0ZM0 2.5H14V4H12.75V11.75C12.75 12.9927 11.7426 14 10.5 14L3.65821 14C2.41556 14 1.4082 12.9927 1.4082 11.75V4H0V2.5ZM2.9082 4H11.25V11.75C11.25 12.1642 10.9142 12.5 10.5 12.5L3.6582 12.5C3.24399 12.5 2.9082 12.1642 2.9082 11.75V4ZM6.25 5.75V10.75H4.75V5.75H6.25ZM9.25 10.75V5.75H7.75V10.75H9.25Z" />
                            </svg>
                        </div>
                        <div class="text-xl font-medium text-base-content">{{ $tt('删除文件夹') }}</div>
                    </div>
                    <button @click="$refs.remove_folder.close()" 
                            class="btn btn-ghost btn-sm btn-circle"
                            :aria-label="$tt('关闭对话框')">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>

                <!-- 内容区域 -->
                <div class="py-6 space-y-6">
                    <!-- 操作提醒 -->
                    <div class="bg-base-200/30 p-4 rounded-lg border border-base-300/50">
                        <div class="flex items-start space-x-3">
                            <svg class="w-5 h-5 fill-base-content/60 flex-shrink-0 mt-0.5" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                            </svg>
                            <div class="text-sm text-base-content/80">
                                <div class="font-medium text-base-content mb-1">{{ $tt('操作提醒') }}</div>
                                <div>{{ $tt('此操作将会删除选中的文件夹，请谨慎选择删除模式') }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- 分组：删除模式选择 -->
                    <div class="space-y-4">
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                            <h3 class="text-lg font-semibold text-base-content">{{ $tt('删除模式') }}</h3>
                            <div class="badge badge-primary badge-outline badge-sm">{{ $tt('3 种模式') }}</div>
                        </div>
                        
                        <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                            <!-- 删除空文件夹 -->
                            <label class="label cursor-pointer justify-start space-x-3 py-3 px-4 rounded-lg border border-base-200 hover:border-primary/30 transition-colors">
                                <input type="radio" name="deleteMode" class="radio radio-primary" 
                                       value="null" v-model="deleteMode" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content">{{ $tt('删除空文件夹') }}</div>
                                    <div class="text-sm text-base-content/60 mt-1">{{ $tt('仅删除完全空的文件夹') }}</div>
                                </div>
                            </label>

                            <!-- 删除无音乐文件夹 -->
                            <label class="label cursor-pointer justify-start space-x-3 py-3 px-4 rounded-lg border border-base-200 hover:border-primary/30 transition-colors">
                                <input type="radio" name="deleteMode" class="radio radio-primary" 
                                       value="null_music" v-model="deleteMode" />
                                <div class="flex-1">
                                    <div class="font-medium text-base-content">{{ $tt('删除无音乐文件夹') }}</div>
                                    <div class="text-sm text-base-content/60 mt-1">{{ $tt('删除不包含音乐文件的文件夹') }}</div>
                                </div>
                            </label>

                            <!-- 危险操作：删除所有 -->
                            <label class="label cursor-pointer justify-start space-x-3 py-3 px-4 rounded-lg border border-error/30 bg-error/5 hover:border-error/50 transition-colors">
                                <input type="radio" name="deleteMode" class="radio radio-error" 
                                       value="all" v-model="deleteMode" />
                                <div class="flex-1">
                                    <div class="font-medium text-error">{{ $tt('删除勾选所有文件夹和文件') }}</div>
                                    <div class="text-sm text-error/70 mt-1">
                                        {{ $tt('⚠️ 危险操作：此操作无法撤销，请谨慎使用') }}
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- 底部操作区域 -->
                <div class="flex items-center justify-end space-x-3 pt-4 border-t border-base-200">
                    <button class="btn btn-sm" @click="$refs.remove_folder.close()">{{ $tt('取消') }}</button>
                    <button class="btn btn-sm" @click="removeNullFolderFunc" 
                            :class="{ 'btn-error': deleteMode === 'all', 'btn-neutral': deleteMode !== 'all' }">
                        {{ $tt('确认') }}
                    </button>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import SingleSelect from "@/components/iview/SingleSelect";
import SingleInput from "@/components/iview/SingleInput";
import MultiSelect from "@/components/iview/MultiSelect";

export default {
    name: 'FileOperations',
    components: { SingleInput, SingleSelect, MultiSelect },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tidyFolderCheckBox: false,
            deleteMode: 'null',
            tidyList: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'album_artist', name: '专辑艺术家' },
                { id: 'album_type', name: '专辑类型' },
                { id: 'genre', name: '风格' },
                { id: 'language', name: '语言' },
                { id: 'track_number', name: '音轨号' },
                { id: 'disc_number', name: '光盘编号' },
                { id: 'comment', name: '描述' },
                { id: 'custom', name: '自定义' }
            ],
            tidyFormData: {
                root_path: localStorage.getItem('tidy_root_path') || '/app/media/',
                dir_list: JSON.parse(localStorage.getItem('tidy_dir_list') || 'null') || [{ 'value': 'artist', 'value2': '' }, { 'value': 'album', 'value2': '' }]
            },
            ruleForm: {
                is_clean_music: false,
                clean_format_priority: ['flac', 'mp3'],
                clean_size_rule: 'smaller',
                clean_bitrate_rule: 'none',
                clean_sample_rule: 'none',
                clean_name_rule: 'none',
                clean_delete_rule: 'delete'
            },
            sizeRuleList: [
                { 'id': 'larger', 'name': '删除较大文件' },
                { 'id': 'smaller', 'name': '删除较小文件' },
                { 'id': 'none', 'name': '不判断' },
            ],
            bitRuleList: [
                { 'id': 'larger', 'name': '删除较大比特率' },
                { 'id': 'smaller', 'name': '删除较小比特率' },
                { 'id': 'none', 'name': '不判断' },
            ],
            sampleRuleList: [
                { 'id': 'larger', 'name': '删除较大采样率' },
                { 'id': 'smaller', 'name': '删除较小采样率' },
                { 'id': 'none', 'name': '不判断' },
            ],
            nameRuleList: [
                { 'id': 'larger', 'name': '删除含有后缀名' },
                { 'id': 'smaller', 'name': '删除不含有后缀名' },
                { 'id': 'none', 'name': '不判断' },
            ],
            formatList: [
                { id: 'flac', name: 'FLAC' },
                { id: 'mp3', name: 'MP3' },
                { id: 'ape', name: 'APE' },
                { id: 'wav', name: 'WAV' },
                { id: 'aiff', name: 'AIFF' },
                { id: 'aif', name: 'AIF' },
                { id: 'tta', name: 'TTA' },
                { id: 'm4a', name: 'M4A' },
                { id: 'ogg', name: 'OGG' },
                { id: 'opus', name: 'OPUS' },
                { id: 'wma', name: 'WMA' },
                { id: 'dsf', name: 'DSF' },
                { id: 'dff', name: 'DFF' },
                { id: 'wmv', name: 'WMV' },
                { id: 'dts', name: 'DTS' },
                { id: 'aac', name: 'AAC' }
            ],
            deleteRuleList: [
                { 'id': 'delete', 'name': '删除' },
                { 'id': 'move', 'name': '移动' },
            ]
        }
    },
    methods: {
        openTidyFolderDrawer() {
            this.tidyFolderCheckBox = true
        },
        closeTidyFolderDrawer() {
            this.tidyFolderCheckBox = false
        },
        isTidyFolderDrawerOpen() {
            return this.tidyFolderCheckBox
        },
        openRemoveFolderDialog() {
            if (this.$refs.remove_folder && typeof this.$refs.remove_folder.showModal === 'function') {
                this.$refs.remove_folder.showModal()
            }
        },
        closeRemoveFolderDialog() {
            if (this.$refs.remove_folder && typeof this.$refs.remove_folder.close === 'function') {
                this.$refs.remove_folder.close()
            }
        },
        isRemoveFolderDialogOpen() {
            return Boolean(this.$refs.remove_folder && this.$refs.remove_folder.open)
        },
        translateOptions(options) {
            return (options || []).map(item => ({
                ...item,
                name: this.$tt(item.name)
            }))
        },
        handleTidy() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.tidyFormData['file_full_path'] = this.filePath
            this.tidyFormData['select_data'] = this.checkedData
            this.tidyFormData['rule_form'] = this.ruleForm

            this.$api.Task.tidyFolder(this.tidyFormData).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    localStorage.setItem('tidy_root_path', this.tidyFormData.root_path)
                    localStorage.setItem('tidy_dir_list', JSON.stringify(this.tidyFormData.dir_list))
                    this.tidyFolderCheckBox = false
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        removeNullFolderFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.removeNullFolder({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'delete_mode': this.deleteMode
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$refs.remove_folder.close()
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        addInput() {
            this.tidyFormData.dir_list.push({ value: '', value2: '' });
        },

        removeInput(index) {
            this.tidyFormData.dir_list.splice(index, 1);
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}
</style>
